import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { BiCoin } from "react-icons/bi";
import {
  BsArrowRightShort,
  BsFiletypeCsv,
  BsFiletypeDocx,
  BsFiletypeHtml,
  BsFiletypeMd,
  BsFiletypeMp3,
  BsFiletypeMp4,
  BsFiletypePdf,
  BsFiletypePptx,
  BsFiletypePy,
  BsFiletypeTxt,
  BsFiletypeXls,
  BsFiletypeXlsx,
  BsTextParagraph,
} from "react-icons/bs";
import { CgSoftwareDownload } from "react-icons/cg";
import { CiFlag1 } from "react-icons/ci";
import {
  FaBuilding,
  FaCalendar,
  FaCheck,
  FaClock,
  FaCheckCircle,
  FaDiscord,
  FaFile,
  FaFileAlt,
  FaGithub,
  FaLinkedin,
  FaQuestionCircle,
  FaRegFileAlt,
  FaRegFileAudio,
  FaRegFolder,
  FaRegKeyboard,
  FaRegStar,
  FaRegThumbsDown,
  FaRegThumbsUp,
  FaSort,
  FaTwitter,
  FaUnlock,
} from "react-icons/fa";
import { FaInfo } from "react-icons/fa6";
import { FiUpload } from "react-icons/fi";
import { GoLightBulb } from "react-icons/go";
import { HiBuildingOffice } from "react-icons/hi2";
import {
  IoIosAdd,
  IoIosRadio,
  IoIosSend,
  IoMdClose,
  IoMdContacts,
  IoMdLogOut,
  IoMdSync,
} from "react-icons/io";
import {
  IoArrowUpCircleOutline,
  IoChatbubbleEllipsesOutline,
  IoCloudDownloadOutline,
  IoFootsteps,
  IoHelp,
  IoShareSocial,
  IoWarningOutline,
} from "react-icons/io5";
import { LiaFileVideo, LiaRobotSolid } from "react-icons/lia";
import { IconType } from "react-icons/lib";
import {
  LuArrowLeftFromLine,
  LuBrain,
  LuBrainCircuit,
  LuChevronDown,
  LuChevronLeft,
  LuChevronRight,
  LuCopy,
  LuExternalLink,
  LuGoal,
  LuChevronUp,
  LuSearch,
} from "react-icons/lu";
import {
  MdDashboardCustomize,
  MdDynamicFeed,
  MdFeedback,
  MdLink,
  MdManageAccounts,
  MdMarkEmailRead,
  MdMarkEmailUnread,
  MdOutlineEmojiEmotions,
  MdOutlineLightMode,
  MdOutlineMail,
  MdOutlineModeEditOutline,
  MdOutlinePalette,
  MdOutlineVpnKey,
  MdUnfoldLess,
  MdUnfoldMore,
  MdUploadFile,
} from "react-icons/md";
import { PiOfficeChairFill } from "react-icons/pi";
import { RiDeleteBackLine, RiHashtag } from "react-icons/ri";
import { SlOptionsVertical } from "react-icons/sl";
import { TbNetwork, TbProgress, TbRobot } from "react-icons/tb";
import { VscGraph, VscTools } from "react-icons/vsc";

import {
  AddKnowledge,
  Approve,
  ArrowBack,
  ArrowRight,
  BookIcon,
  CreateKnowledge,
  Eye,
  EyeOff,
  InfoCircle,
  KnowledgeBaseIcon,
  MenuHome,
  MenuNotifications,
  MenuOverview,
  MenuSettings,
  MenuSources,
  MenuThreads,
  Plus,
  Trash,
  UploadFile,
  User,
} from "./customIcons";

export const iconList: { [name: string]: IconType } = {
  add: Plus,
  addKnowledge: AddKnowledge,
  addWithoutCircle: IoIosAdd,
  createKnowledge: CreateKnowledge,
  arrowBack: ArrowBack,
  arrowRight: ArrowRight,
  assistant: TbRobot,
  back: RiDeleteBackLine,
  bib: FaFile,
  brain: LuBrain,
  brainCircuit: LuBrainCircuit,
  calendar: FaCalendar,
  chair: PiOfficeChairFill,
  chat: IoChatbubbleEllipsesOutline,
  check: FaCheck,
  checkCircle: FaCheckCircle,
  chevronUp: LuChevronUp,
  clock: FaClock,
  chevronDown: LuChevronDown,
  chevronLeft: LuChevronLeft,
  chevronRight: LuChevronRight,
  close: IoMdClose,
  coin: BiCoin,
  color: MdOutlinePalette,
  copy: LuCopy,
  custom: MdDashboardCustomize,
  delete: Trash,
  discord: FaDiscord,
  doc: BsFiletypeDocx,
  docx: BsFiletypeDocx,
  download: IoCloudDownloadOutline,
  edit: MdOutlineModeEditOutline,
  email: MdOutlineMail,
  emoji: MdOutlineEmojiEmotions,
  epub: FaFile,
  eureka: GoLightBulb,
  externLink: LuExternalLink,
  eye: Eye,
  eyeOff: EyeOff,
  feed: MdDynamicFeed,
  feedback: MdFeedback,
  file: FaRegFileAlt,
  fileSelected: FaFileAlt,
  flag: CiFlag1,
  fold: MdUnfoldLess,
  folder: FaRegFolder,
  followUp: IoArrowUpCircleOutline,
  github: FaGithub,
  goal: LuGoal,
  graph: VscGraph,
  hashtag: RiHashtag,
  help: IoHelp,
  hide: LuArrowLeftFromLine,
  history: MenuThreads,
  home: MenuHome,
  html: BsFiletypeHtml,
  info: FaInfo,
  infoCircle: InfoCircle,
  invite: IoIosSend,
  ipynb: BsFiletypePy,
  key: MdOutlineVpnKey,
  link: MdLink,
  linkedin: FaLinkedin,
  loader: AiOutlineLoading3Quarters,
  logout: IoMdLogOut,
  m4a: LiaFileVideo,
  markdown: BsFiletypeMd,
  md: BsFiletypeMd,
  mp3: BsFiletypeMp3,
  mp4: BsFiletypeMp4,
  mpga: FaRegFileAudio,
  mpeg: LiaFileVideo,
  notifications: MenuNotifications,
  office: HiBuildingOffice,
  odt: BsFiletypeDocx,
  options: SlOptionsVertical,
  overview: MenuOverview,
  paragraph: BsTextParagraph,
  pptx: BsFiletypePptx,
  prompt: FaRegKeyboard,
  py: BsFiletypePy,
  question: FaQuestionCircle,
  radio: IoIosRadio,
  read: MdMarkEmailRead,
  redirection: BsArrowRightShort,
  robot: LiaRobotSolid,
  search: LuSearch,
  settings: MenuSettings,
  share: IoShareSocial,
  software: CgSoftwareDownload,
  sort: FaSort,
  sources: MenuSources,
  star: FaRegStar,
  step: IoFootsteps,
  sun: MdOutlineLightMode,
  sync: IoMdSync,
  telegram: BsFiletypeDocx,
  thumbsDown: FaRegThumbsDown,
  thumbsUp: FaRegThumbsUp,
  twitter: FaTwitter,
  unfold: MdUnfoldMore,
  unlock: FaUnlock,
  unread: MdMarkEmailUnread,
  upload: FiUpload,
  uploadFile: MdUploadFile,
  user: User,
  waiting: TbProgress,
  warning: IoWarningOutline,
  wav: FaRegFileAudio,
  webm: LiaFileVideo,
  website: TbNetwork,
  xls: BsFiletypeXls,
  xlsx: BsFiletypeXlsx,
  txt: BsFiletypeTxt,
  csv: BsFiletypeCsv,
  pdf: BsFiletypePdf,
  contacts: IoMdContacts,
  orgManagement: MdManageAccounts,
  building: FaBuilding,
  tool: VscTools,
  trash: Trash,
  approve: Approve,
  kb: KnowledgeBaseIcon,
  book: BookIcon,
  uploadFileImage: UploadFile,
};
